// extracted by mini-css-extract-plugin
export const layoutContainer = "layout-module--layoutContainer--3OFLg";
export const pageTitle = "layout-module--pageTitle--2jHGv";
export const layoutBody = "layout-module--layoutBody---wTtt";